import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SelectionModel } from "@angular/cdk/collections";
import { TableComponent } from "src/app/table.component";
import { ComprehensiveOrderService } from "src/services/comprehensive-order.service";
import { ReportService } from "src/services/report.service";
import { Helpers } from "src/helpers/helpers";
import { AccountService } from "src/services/account.service";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";

@Component({
  selector: "app-comprehensive-order",
  templateUrl: "./comprehensive-order.component.html",
  styleUrls: ["./comprehensive-order.component.css"],
})
export class ComprehensiveOrderComponent extends TableComponent<Request> {
  pageTitle = "Orders";
  displayedColumns: string[] = [
    "id",
    "issueDate",
    "orderDate",
    "ownerName",
    "type",
    "plateNo",
    "insurer",
    "policyNumber",
    "addOn",
    "amount",
    "paymentToken",
    "status",
  ];

  selection = new SelectionModel<any>(true, []);
  status: string = "all";
  search: string = "";
  issueDateFrom: string = "";
  issueDateTo: string = "";
  forAgency: boolean = false;

  constructor(
    orderService: ComprehensiveOrderService,
    private router: Router,
    private _reportService: ReportService,
    private route: ActivatedRoute,
    private helper: Helpers,
    private accountService: AccountService,
    private snackBar: MatSnackBar
  ) {
    super(orderService);
    this.forAgency = this.route.snapshot.data["forAgency"];
    const userType = this.helper.getDecodedAccessToken(
      window.localStorage.token
    ).type;
    if (
      userType.indexOf("LEVEL 0") === 0 ||
      userType.indexOf("LEVEL 1") === 0 ||
      userType.indexOf("LEVEL 2") === 0
    ) {
      this.accountService.getAccount().subscribe((data) => {
        if (!data.activated) {
          this.helper.logout();
          this.router.navigate(["/"]);
          this.snackBar.open(
            "Your account is not active, please contact admin.",
            "Close",
            {
              duration: 3000,
            }
          );
        }
      });
    }
  }

  openOrder(data: any) {
    this.router.navigate(["/comprehensive-orders/" + data.rateCardId]);
  }

  onSubmit(): void {
    this.getCount().subscribe((res) => {
      this.count = res.count;
      this.loadRequests();
    });
  }

  getCount() {
    return this.countService.getCount({
      filter: this.search ?? "",
      statuses: this.status === "all" || !this.status ? [] : [this.status],
      startPolicyIssueDate: this.issueDateFrom ?? "",
      endPolicyIssueDate: this.issueDateTo ?? "",
      forAgency: this.forAgency,
    });
  }

  getData() {
    let pageSize = this.paginator.pageSize ? this.paginator.pageSize : 10;
    return {
      skip: this.paginator.pageIndex * pageSize,
      take: pageSize,
      filter: this.search ?? "",
      statuses: this.status === "all" || !this.status ? [] : [this.status],
      startPolicyIssueDate: this.issueDateFrom ?? "",
      endPolicyIssueDate: this.issueDateTo ?? "",
      orderBy: this.sort.active,
      orderByDescending: this.sort.direction === "desc",
      forAgency: this.forAgency,
    };
  }

  downloadReport(isXLS: boolean) {
    const data = {
      filter: this.search ?? "",
      statuses: this.status === "all" || !this.status ? [] : [this.status],
      startPolicyIssueDate: this.issueDateFrom ?? "",
      endPolicyIssueDate: this.issueDateTo ?? "",
      asXLS: isXLS,
      forAgency: this.forAgency,
    };
    this._reportService.downloadReport(
      "DownloadComprehensivePoliciesReport",
      data
    );
  }
}
